import React, { useEffect } from 'react'

import { GameId } from '@common'

import { setStorefront } from '@/features/locale/configSlice'
import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import { GameProvider } from '../../game-provider'
import { CartProvider } from '../cart/cart-provider'
import { MenuProvider } from '../header/menu/menu-provider'

export const StorefrontWrapper = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setStorefront(true))
  }, [dispatch])

  const gameId = useAppSelector((state) => state.common.currentGame) as GameId

  if (!gameId) {
    return null
  }

  return (
    <GameProvider gameSlug={gameId}>
      <MenuProvider>
        <CartProvider>{children}</CartProvider>
      </MenuProvider>
    </GameProvider>
  )
}

StorefrontWrapper.displayName = 'StorefrontWrapper'
